import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import qmsDocumentActions from "../../../_actions/_qmsActions/qmsDocumentActions";
import { useMemo } from "react";
import qmsDocumentTypeActions from "../../../_actions/_qmsActions/qmsDocumentTypeActions";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import { QmsDataTable } from "../_common/QmsDataTable";
import QmsAdminModal_EditDocument from "./QmsAdminModal_EditDocument";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function QmsAdminDocuments(props) {
  const { divisionId } = props;

  const columns = [
    {
      id: "number",
      numeric: true,
      disablePadding: false,
      label: "No.",
    },
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      label: "Title",
      render: (rowData) => (
        <>
          {rowData.title}
          {rowData.originalFilename && (
            <FontAwesomeIcon icon="paperclip" className="ml-1" />
          )}
        </>
      ),
    },
    {
      id: "type",
      numeric: false,
      disablePadding: false,
      label: "Document Type",
      render: (rowData) => {
        if (!rowData.qmsDocumentTypeId)
          return (
            <span className="badge badge-secondary qms-admin__inline-list--item">
              (N/A)
            </span>
          );
        const type = (qmsDocumentTypes || []).find(
          (qdt) => qdt.qmsDocumentTypeId === rowData.qmsDocumentTypeId
        );
        return (
          <span className="badge badge-secondary qms-admin__inline-list--item">
            {type ? type.label : "(N/A)"}
          </span>
        );
      },
    },
    {
      id: "owner",
      numeric: false,
      disablePadding: false,
      label: "Owner",
      render: (rowData) => {
        if (!rowData.ownerTeamId)
          return (
            <span className="badge badge-secondary qms-admin__inline-list--item">
              (N/A)
            </span>
          );
        const owner = (qmsTeams || []).find((qt) => qt.qmsTeamId === rowData.ownerTeamId);
        return (
          <span className="badge badge-secondary qms-admin__inline-list--item">
            {owner ? owner.name : "(N/A)"}
          </span>
        );
      },
    },
    {
      id: "lastRevisedOn",
      numeric: true,
      disablePadding: false,
      label: "Published/Revised On",
      render: (rowData) =>
        rowData.lastRevisedOn
          ? new Date(Date.parse(rowData.lastRevisedOn)).toLocaleDateString()
          : "(N/A)",
    },
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(qmsDocumentActions.getAll(divisionId));
    dispatch(qmsDocumentTypeActions.getAll(divisionId));
    dispatch(qmsTeamActions.getAll(divisionId));
  }, [divisionId]);

  const qmsDocumentTypes = useSelector(
    (state) => state.qms.qmsDocumentTypes[divisionId] || null
  );
  const qmsDocuments = useSelector((state) => state.qms.qmsDocuments[divisionId] || null);
  const qmsTeams = useSelector((state) => state.qms.qmsTeams[divisionId] || null);

  return (
    <QmsDataTable
      data={qmsDocuments}
      columns={columns}
      idName="qmsDocumentId"
      editModalComponent={<QmsAdminModal_EditDocument divisionId={divisionId} />}
      onDelete={(ids) => dispatch(qmsDocumentActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
